import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, initializeAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyChZ5QDXfS-OGs356aCNzCvsSKx8XomDZ4',
  authDomain: 'mesterplan-ddee7.firebaseapp.com',
  projectId: 'mesterplan-ddee7',
  storageBucket: 'mesterplan-ddee7.firebasestorage.app',
  messagingSenderId: '607492837640',
  appId: '1:607492837640:web:75e1da7c3dc892ad485cbd',
};

const app = initializeApp(firebaseConfig);

export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');
